import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Spinner from "../../../component/spinner/Spinner"
import GetUsersServices from "../../../services/GetUsersServices";
import EmployeeLoggedView from "./EmployeeLoggedView"
import EmployeeNotLoggedView from './EmployeeNotLoggedView';

export default function HomeViewEmployees() {

    const [searchParams] = useSearchParams();
    const [getUser, setGetUser] = useState([]);
    const [loading, setLoading] = useState(true);

    const idSellerParams = searchParams.get ('idven');
    const userParams = searchParams.get ('idusr');
    const idSessionParams = searchParams.get ('idsession');
    
    useEffect(() => {
        const getUser = async () => {
            const userData = await GetUsersServices(userParams);
            setGetUser(userData);
            setLoading(false);
        };
        getUser();
    }, [userParams]);

    if (loading) {
        return <Spinner />; 
    }

    if (getUser[0]?.TxtError) {
        return (
            <StyledHomeViewEmployees>
                <div className="contenInit">
                    <p>{getUser[0].TxtError}</p>
                </div>
            </StyledHomeViewEmployees>
        )
    }

    return (
        <StyledHomeViewEmployees>
            <div className='container containerApp'>
                <div className="row">
                    <div className="col-12">
                        <h2 style={{ marginTop: '2rem', textAlign: 'center' }}>
                            {idSessionParams === null ?
                                <EmployeeNotLoggedView users={getUser} /> :
                                <EmployeeLoggedView users={getUser} seller={idSellerParams} />}
                        </h2>
                        
                    </div>
                </div>
            </div>
        </StyledHomeViewEmployees>
    );
};

const StyledHomeViewEmployees = styled.div`
    .contenInit{
        background-color: #face55;
        width:85%;
        padding: 2rem 4rem;
        margin: 0 auto;
        border-radius: 1rem;
        margin-top: 4rem;
        text-align: center;
    }
    h4 {
        margin: 3rem 0rem;
    } 
    
`